import { useCallback } from 'react';
import { searchRows, sortRows } from '../utils';

export const useDashboardDataTableSortSearch = ({ searchableColumns = [] }) => {
  const executeSearchSort = useCallback(
    ({ rows, search, sortBy }) => {
      const searchedRows = searchRows(search, {
        rows,
        columnIds: searchableColumns,
      });

      return sortRows(searchedRows, sortBy);
    },
    [searchableColumns]
  );

  return { executeSearchSort };
};
